import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
//import _ from "lodash";
import LegalEditForm from './../../elements/revision/legal';
import Loading from "../../elements/loading";
//import {history} from "../../store/store";

class RevisionLegal extends Component {
	render (){
		let { revision } = this.props;
		return (
			revision.isFetching ? <Loading /> : <LegalEditForm {...this.props}/>
		);
	}

	componentWillMount() {
		let {state, municipality, modality} = this.props.match.params;
		this.props.fetchRevisionLegal(modality, state, municipality);
	}

	componentWillReceiveProps(nextprops) {
		if(nextprops.match.params !== this.props.match.params) {
			let {modality, state, municipality} = nextprops.match.params;

			this.props.fetchRevisionLegal(modality, state, municipality);
		}
	}
}

export default BaseLayout(RevisionLegal, {
	title:"Revisión Jurídica",
	subnav:{
		icon: 'fa-check-square-o',
		name: 'Revisión'
	}, stateNav: true
});



// WEBPACK FOOTER //
// ./src/layouts/revision/legal.jsx